import React, { createContext, useState } from 'react';

export const NoAccountsRedirectContext = createContext<{
  ignoreNoAccounts: boolean;
  setIgnoreNoAccounts: React.Dispatch<React.SetStateAction<boolean>>;
}>({
  ignoreNoAccounts: false,
  setIgnoreNoAccounts: () => false,
});

export const NoAccountsRedirectProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [ignoreNoAccounts, setIgnoreNoAccounts] = useState<boolean>(false);

  return (
    <NoAccountsRedirectContext.Provider
      value={{
        ignoreNoAccounts,
        setIgnoreNoAccounts,
      }}
    >
      {children}
    </NoAccountsRedirectContext.Provider>
  );
};
